"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var skynet_store_manager_1 = require("@synisys/skynet-store-manager");
var lodash_1 = require("lodash");
var kb_state_1 = require("./kb.state");
var category_store_manager_1 = require("./manager/category-store.manager");
var field_store_manager_1 = require("./manager/field-store.manager");
var categoryStoreManagerFactory = function () {
    var cache = {};
    return function (prefix) {
        var actualPrefix = lodash_1.isNil(prefix) ? kb_state_1.defaultKbKey : prefix;
        if (lodash_1.isNil(cache[actualPrefix])) {
            cache[actualPrefix] = new category_store_manager_1.CategoryStoreManager("kb.categories", function (item) { return item.metaCategoryId.systemName.toLowerCase(); }, actualPrefix);
        }
        return cache[actualPrefix];
    };
};
var ɵ0 = categoryStoreManagerFactory;
exports.ɵ0 = ɵ0;
exports.categoryStoreManager = categoryStoreManagerFactory();
var fieldStoreManagerFactory = function () {
    var cache = {};
    return function (prefix) {
        var actualPrefix = lodash_1.isNil(prefix) ? kb_state_1.defaultKbKey : prefix;
        if (lodash_1.isNil(cache[actualPrefix])) {
            cache[actualPrefix] = new field_store_manager_1.FieldStoreManager("kb.fields", function (item) { return item.metaFieldId.systemName.toLowerCase(); }, actualPrefix);
        }
        return cache[actualPrefix];
    };
};
var ɵ1 = fieldStoreManagerFactory;
exports.ɵ1 = ɵ1;
exports.fieldStoreManager = fieldStoreManagerFactory();
var groupStoreManagerFactory = function () {
    var cache = {};
    return function (prefix) {
        var actualPrefix = lodash_1.isNil(prefix) ? kb_state_1.defaultKbKey : prefix;
        if (lodash_1.isNil(cache[actualPrefix])) {
            cache[actualPrefix] = new skynet_store_manager_1.DynamicEntityStoreManager("kb.groups", function (item) { return item.systemName.toLowerCase(); }, actualPrefix);
        }
        return cache[actualPrefix];
    };
};
var ɵ2 = groupStoreManagerFactory;
exports.ɵ2 = ɵ2;
exports.groupStoreManager = groupStoreManagerFactory();
//# sourceMappingURL=kb.store.js.map